import { connect } from 'react-redux';

import { getVisibleElement } from 'selectors/drawer';
import { getCurrentUserIdSelector } from 'selectors/user';

import { getErrorSelector, getIsReadySelector } from 'selectors/session';
import PageLayout from './index';

const mapStateToProps = state => {
    const { router } = state;
    const drawer = getVisibleElement(state.drawer);
    const modal = getVisibleElement(state.modal);
    const _user = getCurrentUserIdSelector(state);

    return {
        isLoading: !getIsReadySelector(state),
        hasError: !!getErrorSelector(state),
        location: router.location,
        _currentUser: _user,
        drawerType: drawer ? drawer.key : null,
        modalType: modal ? modal.key : null
    };
};


export default connect(
    mapStateToProps,
    null
)(PageLayout);
